/* eslint-disable import/no-anonymous-default-export */
import ctx from "../../plugins/axios";
export default async (filedata) => {
  return await ctx.post("/specialty_list/import", filedata);
};
